import { selectCarDayWorkDistribution, selectCarHomeworkDetails, selectCarOverview, selectCarHomeworkTable, selectDriverHomeworkDetails, selectDriverHomeworkTable, selectCarHomeworkWork, selectDriverHomeworkWork } from "../../api/config/modules/ReportAnalysis";

const state = {
  selectCarDayWorkDistribution: {},
  selectCarHomeworkDetails: {},
  selectCarOverview: {},
  selectCarHomeworkTable: {},
  selectDriverHomeworkDetails: {},
  selectDriverHomeworkTable: {},
  selectCarHomeworkWork: {},
  selectDriverHomeworkWork: {}
};

const mutations = {
  SET_SELECTCARDAYWORKDISTRIBUTION: (state, selectCarDayWorkDistribution) => {
    state.selectCarDayWorkDistribution = selectCarDayWorkDistribution;
  },
  SET_SELECTCARHOMEWORKDETAILS: (state, selectCarHomeworkDetails) => {
    state.selectCarHomeworkDetails = selectCarHomeworkDetails;
  },
  SET_SELECTCAROVERVIEW: (state, selectCarOverview) => {
    state.selectCarOverview = selectCarOverview;
  },
  SET_SELECTCARHOMEWORKTABLE: (state, selectCarHomeworkTable) => {
    state.selectCarHomeworkTable = selectCarHomeworkTable;
  },
  SET_SELECTDRIVERHOMEWORKDETAILS: (state, selectDriverHomeworkDetails) => {
    state.selectDriverHomeworkDetails = selectDriverHomeworkDetails;
  },
  SET_SELECTDRIVERHOMEWORKTABLE: (state, selectDriverHomeworkTable) => {
    state.selectDriverHomeworkTable = selectDriverHomeworkTable;
  },
  SET_SELECTCARHOMEWORKWORK: (state, selectCarHomeworkWork) => {
    state.selectCarHomeworkWork = selectCarHomeworkWork;
  },
  SET_SELECTDRIVERHOMEWORKWORK: (state, selectDriverHomeworkWork) => {
    state.selectDriverHomeworkWork = selectDriverHomeworkWork;
  },
};

const actions = {
  GET_SELECTCARDAYWORKDISTRIBUTION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarDayWorkDistribution(data)
        .then((res) => {
          commit("SET_SELECTCARDAYWORKDISTRIBUTION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCARHOMEWORKDETAILS: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarHomeworkDetails(data)
        .then((res) => {
          commit("SET_SELECTCARHOMEWORKDETAILS", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCAROVERVIEW: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarOverview(data)
        .then((res) => {
          commit("SET_SELECTCAROVERVIEW", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCARHOMEWORKTABLE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarHomeworkTable(data)
        .then((res) => {
          commit("SET_SELECTCARHOMEWORKTABLE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVERHOMEWORKDETAILS: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverHomeworkDetails(data)
        .then((res) => {
          commit("SET_SELECTDRIVERHOMEWORKDETAILS", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVERHOMEWORKTABLE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverHomeworkTable(data)
        .then((res) => {
          commit("SET_SELECTDRIVERHOMEWORKTABLE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCARHOMEWORKWORK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarHomeworkWork(data)
        .then((res) => {
          commit("SET_SELECTCARHOMEWORKWORK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVERHOMEWORKWORK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverHomeworkWork(data)
        .then((res) => {
          commit("SET_SELECTDRIVERHOMEWORKWORK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
